import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import { CountriesStatesCities } from "./components/CountriesStatesCities";
import ReduxDemo from "./components/ReduxDemo";
import { Chatbot } from "./components/Chatbot";
import { Imagebot } from "./components/Imagebot";
import { Translator } from "./components/Translator";
import { ArchiveSearcher } from "./components/ArchiveSearcher";
import OcrTool from "./components/OcrTool";
import InfiniteScroll from "./components/InfiniteScroll";
import MediaViewer from "./components/MediaViewer";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ChangePassword from "./components/auth/ChangePassword";
import RolesList from "./components/auth/RolesList";
import UsersList from "./components/auth/UsersList";
import EditUser from './components/auth/EditUser';
import AppUsersList from './components/auth/AppUsersList'; 
import EditAppUser from "./components/auth/EditAppUser";

const AppRoutes = [
    {
        index: true,
        isProtected: false,
        element: <Home />
    },
    {
        path: '/counter',
        isProtected: false,
        element: <Counter />
    },
    {
        path: '/fetch-data',
        isProtected: false,
        element: <FetchData />
    },
    {
        path: '/world-cities',
        isProtected: false,
        element: <CountriesStatesCities />
    },
    {
        path: '/register',
        isProtected: false,
        element: <Register />
    },
    {
        path: '/login',
        isProtected: false,
        element: <Login />
    },
    {
        path: '/admin/changepassword',
        isProtected: true,
        element: <ChangePassword />
    },
    {
        path: '/admin/roles',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <RolesList />
    },
    {
        path: '/admin/users',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <UsersList />
    },
    {
        path: '/admin/users/add',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <EditUser />
    },
    {
        path: '/admin/users/edit/:userId',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <EditUser />
    },
    {
        path: '/admin/appusers',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <AppUsersList />
    },
    {
        path: '/admin/appusers/add',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <EditAppUser />
    },
    {
        path: '/admin/appusers/edit/:id',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <EditAppUser />
    },
    {
        path: '/admin/appusers',
        isProtected: true,
        allowedRoles: ['Admin'],
        element: <AppUsersList />
    },
    {
        path: '/redux-demo',
        isProtected: false,
        element: <ReduxDemo />
    },
    {
        path: '/Home/Chatbot',
        isProtected: false,
        element: <Chatbot />
    },
    {
        path: '/Home/Imagebot',
        isProtected: false,
        element: <Imagebot />
    },
    {
        path: '/Home/Translator',
        isProtected: true,
        element: <Translator />
    },
    {
        path: '/Home/TreeGrid',
        isProtected: true,
        element: <ArchiveSearcher />
    },
    {
        path: '/Home/MediaViewer',
        isProtected: true,
        element: <MediaViewer />
    },
    {
        path: '/Home/OCR',
        isProtected: false,
        element: <OcrTool />
    },
    {
        path: '/Home/InfiniteScroll',
        isProtected: false,
        element: <InfiniteScroll />
    }
];

export default AppRoutes;
